import { render } from "./UploadBar.vue?vue&type=template&id=11cdbe08"
import script from "./UploadBar.vue?vue&type=script&lang=ts"
export * from "./UploadBar.vue?vue&type=script&lang=ts"
script.render = render

export default script